const paths = {
	home: '/',
	intro: {
		philosophy: '/intro/philosophy',
		turnKey: '/intro/turn-key',
		history: '/intro/history'
	},
	portfolio: '/portfolio',
	column: '/column',
	content: { blog: '/content/blog', youtube: '/content/youtube' },
	review: '/review',
	faq: '/faq',
	inquiry: '/inquiry'
};

export default paths;
